<yw-category-image-list [categories]="images" (clicked)="clicked($event)"></yw-category-image-list>

